var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", [
    _c(
      "li",
      {
        staticStyle: {
          float: "left",
          display: "block",
          padding: "10px",
          "text-decoration": "none"
        }
      },
      [
        !_vm.mobileView
          ? _c(
              "div",
              {
                staticClass: "fv ct",
                staticStyle: {
                  position: "relative",
                  width: "300px",
                  height: "300px",
                  "margin-bottom": "10px",
                  background: "#ffffff",
                  "border-style": "solid",
                  "border-width": "1px",
                  border: "1px solid #dddddd",
                  "box-shadow": "1px 1px 2px #dddddd"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fv cc",
                    staticStyle: {
                      "margin-top": "10px",
                      height: "130px",
                      background: "#ffffff"
                    }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.imagenProducto == null,
                          expression: "imagenProducto == null"
                        }
                      ],
                      staticStyle: { width: "200px", height: "120px" },
                      attrs: {
                        id: "imagenPlaceholder",
                        src: "/dist/progress-item.gif"
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.imagenProducto != null,
                          expression: "imagenProducto != null"
                        }
                      ],
                      staticStyle: {
                        width: "200px",
                        height: "120px",
                        "object-fit": "contain"
                      },
                      attrs: { id: "imagenProducto", src: _vm.imagenProducto }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { width: "100%" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        color: "#656E76",
                        "margin-left": "10px",
                        "margin-top": "8px",
                        "font-weight": "500"
                      }
                    },
                    [_vm._v(_vm._s(_vm.item.Titulo))]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        "margin-left": "10px",
                        "margin-right": "10px",
                        height: "45px",
                        overflow: "auto"
                      }
                    },
                    _vm._l(_vm.escalas, function(escala) {
                      return _c(
                        "li",
                        {
                          staticStyle: {
                            "font-size": "9px",
                            color: "#656E76",
                            "margin-bottom": "2px"
                          }
                        },
                        [_vm._v("• " + _vm._s(escala))]
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#656E76",
                        "margin-left": "10px",
                        "margin-top": "5px",
                        "font-weight": "500"
                      }
                    },
                    [_vm._v(_vm._s(_vm.getAlcance))]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        "margin-left": "10px",
                        height: "45px",
                        overflow: "auto"
                      }
                    },
                    _vm._l(_vm.itemsAlcance, function(itemAlcance) {
                      return _c(
                        "li",
                        {
                          staticStyle: {
                            "font-size": "9px",
                            color: "#656E76",
                            "margin-bottom": "2px"
                          }
                        },
                        [_vm._v("• " + _vm._s(itemAlcance))]
                      )
                    })
                  )
                ])
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78ad0a22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ad0a22","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/descuentos/itemDescuento.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-78ad0a22","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/descuentos/itemDescuento.vue
// module chunks = 0